import React, { useState, useEffect } from "react";
import { loadNoSchoolDays } from "../noSchoolDays";
import { fmt, tomorrowStr } from "../dateUtils";
import { getDayInfo } from "../dayInfo";

const PERSON_COLORS = { Adam: "#7A9E87", Kimberly: "#C9847A" };
const ACCENT_MUTED  = { Adam: "#EAF2ED", Kimberly: "#FBF0EF" };
const PERSON_EMOJI  = { Adam: "🏊", Kimberly: "💃" };

function KidCard({ person, onTap }) {
  const accent = PERSON_COLORS[person];
  const accentMuted = ACCENT_MUTED[person];
  const today = getDayInfo(person, fmt(new Date()));
  const tomorrow = getDayInfo(person, tomorrowStr());

  return (
    <div onClick={onTap} style={{ flex: 1, background: "var(--white)", border: "1px solid var(--border)", borderRadius: 14, padding: "12px 14px", cursor: "pointer", minWidth: 0 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
        <div style={{ width: 26, height: 26, borderRadius: "50%", background: accentMuted, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>{PERSON_EMOJI[person]}</div>
        <div style={{ fontSize: 13, fontWeight: 800, color: "var(--charcoal)" }}>{person}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 8 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: 0.3 }}>Today</span>
          <span style={{ fontSize: 13, fontWeight: 800, color: today.label === "No school" ? "var(--muted)" : accent, textAlign: "right" }}>{today.label}{today.sub && ` · ${today.sub}`}</span>
        </div>
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 8 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: 0.3 }}>Tomorrow</span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "var(--mid)", textAlign: "right" }}>{tomorrow.label}{tomorrow.sub && ` · ${tomorrow.sub}`}</span>
        </div>
      </div>
    </div>
  );
}

// Shown on the main family Home dashboard (App.js) so Carissa and Robert
// don't have to open each kid's own dashboard just to see what today and
// tomorrow look like for them. Uses the same getTodaySchedule()/
// getTodaySpecial() calculators as each kid's own dashboard — this
// component just decides which one to call per person and lays out both
// side by side.
export default function TodayTomorrowSection({ onKidTap }) {
  const [, forceUpdate] = useState(0);
  useEffect(() => { loadNoSchoolDays().then(() => forceUpdate(n => n + 1)); }, []);

  return (
    <>
      <div className="section-head"><span className="section-label">Today & Tomorrow</span></div>
      <div style={{ display: "flex", gap: 10, padding: "12px 20px 18px", background: "var(--white)", borderTop: "1px solid var(--border)" }}>
        <KidCard person="Adam" onTap={() => onKidTap?.("Adam")} />
        <KidCard person="Kimberly" onTap={() => onKidTap?.("Kimberly")} />
      </div>
    </>
  );
}
